<template>
  <!-- 线下收款信息 -->
  <div ref="registrInfoRef">
    <!-- 分账资质信息 -->
    <div class="manage-card-box my-5">
      <div class="info-card-title">
        分账资质信息
      </div>
      <div class="base-info-list">
        <div class="left-list gap-y-[14px]">
          <div class="item">
            <div class="label">
              行业
            </div>
            <div class="value">
              {{ categories.find(item=>item.id == Number(data.industryCategory))?.name }} -
              {{ subCategories.find(item=>item.id == Number(data.industrySubcategory))?.name }} - 
              {{ thirdCategories.find(item=>item.id == Number(data.merchantCategory))?.name }}
            </div>
          </div>
          <div class="item">
            <div class="label flex">
              付款协议 <el-tooltip
                class="auth-tooltip"
                effect="light"
                content="提供完整付款协议，且内容需体现出款场景;要求甲乙双方鲜章、骑缝章、协议内容完整"
                placement="right"
              >
                <svg-icon
                  icon="mingcute:information-line"
                  class="main-primary-text cursor-pointer !w-[16px] relative ml-1"
                />
              </el-tooltip>
            </div>
            <div class="value">
              <el-link type="primary" :underline="false" @click="(e) => openService(data.agreementPhotoUrl, e)">
                {{ data.agreementPhotoName }}
              </el-link>
            </div>
          </div>
          
          <template v-if="data.shareScene">
            <div v-for="(item,index) in Comps[data.shareScene]" :key="index" class="item">
              <div class="label flex ">
                {{ item.name }} <el-tooltip
                  v-if="item.desc"
                  class="auth-tooltip"
                  effect="light"
                  :content="item.desc"
                  placement="right"
                >
                  <svg-icon
                    icon="mingcute:information-line"
                    class="main-primary-text cursor-pointer !w-[16px] relative ml-1"
                  />
                </el-tooltip>
              </div>
              <div v-if="item.type=='upload'" class="value">
                <el-link type="primary" :underline="false" @click="(e) => openService(data[`shareCertificate${index+1}`], e)">
                  {{ data[`shareCertificate${index+1}Name`] ? data[`shareCertificate${index+1}Name`] : data[`shareCertificate${index+1}`] }}
                </el-link>
              </div>
              <div v-if="item.type=='img'" class="value">
                <div class="business-license-box">
                  <img :src="data[`shareCertificate${index+1}`]" alt="">
                </div>
              </div>
              <div v-if="item.type=='textarea'" class="value">
                {{ data[`shareCertificate${index+1}`] }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PropType, ref } from 'vue';
import { useElementImgPreview, SvgIcon } from '@vue3/components';
import { IYibaoDetail } from '../../../../types/yibao';
import { queryIndustryTree } from '@core/api';
import { ElMessage } from 'element-plus';
import { Comps } from './meta';

defineOptions({ name: 'OfflinePaymentInfo' });

const props = defineProps({
  data: {
    type: Object as PropType<IYibaoDetail>,
    default() {
      return {} as IYibaoDetail;
    },
  },
});

const registrInfoRef = ref<HTMLDivElement>();

interface IBaseOpt {
  name: string;
  id: number;
  mccCode?: string;
  children?: IBaseOpt[];
}

const categories = ref([] as IBaseOpt[]);
const subCategories = ref([] as IBaseOpt[]);
const thirdCategories = ref([] as IBaseOpt[]);

useElementImgPreview(registrInfoRef);

function openService(url: string, e: MouseEvent) {
  e.stopPropagation();
  window.open(`/account/office-previewer?url=${url}`);
}

async function initIndustryTree() {
  try {
    const data = await queryIndustryTree();

    categories.value = data as IBaseOpt[];
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function initData() {
  if (!categories.value.length) {
    await initIndustryTree();
  }
  
  if (props.data.industryCategory && props.data.industrySubcategory) {
    subCategories.value = categories.value.find((v) => v.id === Number(props.data.industryCategory))?.children || [];
  }

  if (props.data.industryCategory && props.data.industrySubcategory && props.data.merchantCategory) {
    thirdCategories.value = subCategories.value.find((v) => v.id === Number(props.data.industrySubcategory))?.children || [];
  }
  
}

initData();
</script>
